/**
 * @generated SignedSource<<39e0d43d613441ed6d23dfb4355407ee>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type LearningSortEnum = "CREATION_DATE_ASC" | "CREATION_DATE_DESC" | "ID_ASC" | "ID_DESC" | "SUMMARY_ASC" | "SUMMARY_DESC";
export type LearningType = "DECISION" | "LEARNING" | "RISK";
export type TrackViewEvent = "DIRECT" | "INDIRECT" | "SKIP";
export type ProjectLearningsTabQuery$variables = {
  key: string;
  learningsSort?: ReadonlyArray<LearningSortEnum | null> | null;
  tagCount?: number | null;
  trackViewEvent?: TrackViewEvent | null;
  type?: LearningType | null;
};
export type ProjectLearningsTabQuery$data = {
  readonly project: {
    readonly " $fragmentSpreads": FragmentRefs<"ProjectLearningsTabContent">;
  } | null;
};
export type ProjectLearningsTabQuery = {
  response: ProjectLearningsTabQuery$data;
  variables: ProjectLearningsTabQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "key"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "learningsSort"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "tagCount"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "trackViewEvent"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "type"
},
v5 = [
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "key"
  },
  {
    "kind": "Variable",
    "name": "trackViewEvent",
    "variableName": "trackViewEvent"
  }
],
v6 = {
  "kind": "Variable",
  "name": "type",
  "variableName": "type"
},
v7 = {
  "kind": "ScalarField",
  "name": "id"
},
v8 = {
  "kind": "ScalarField",
  "name": "uuid"
},
v9 = [
  {
    "kind": "ScalarField",
    "name": "label"
  }
],
v10 = {
  "concreteType": "ProjectState",
  "kind": "LinkedField",
  "name": "state",
  "plural": false,
  "selections": (v9/*: any*/)
},
v11 = {
  "concreteType": "Workspace",
  "kind": "LinkedField",
  "name": "workspace",
  "plural": false,
  "selections": [
    (v8/*: any*/),
    (v7/*: any*/)
  ]
},
v12 = {
  "kind": "Variable",
  "name": "sort",
  "variableName": "learningsSort"
},
v13 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 200
  },
  (v12/*: any*/),
  (v6/*: any*/)
],
v14 = {
  "kind": "ScalarField",
  "name": "count"
},
v15 = {
  "kind": "ScalarField",
  "name": "summary"
},
v16 = {
  "kind": "ScalarField",
  "name": "ari"
},
v17 = {
  "kind": "ScalarField",
  "name": "key"
},
v18 = {
  "kind": "ScalarField",
  "name": "name"
},
v19 = [
  {
    "concreteType": "UserPII",
    "kind": "LinkedField",
    "name": "pii",
    "plural": false,
    "selections": [
      (v18/*: any*/),
      {
        "kind": "ScalarField",
        "name": "picture"
      },
      {
        "kind": "ScalarField",
        "name": "accountId"
      }
    ]
  },
  {
    "kind": "ScalarField",
    "name": "aaid"
  },
  (v7/*: any*/)
],
v20 = {
  "kind": "ScalarField",
  "name": "watcherCount"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ProjectLearningsTabQuery",
    "selections": [
      {
        "alias": "project",
        "args": (v5/*: any*/),
        "concreteType": "Project",
        "kind": "LinkedField",
        "name": "projectByKey",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "learningsSort",
                "variableName": "learningsSort"
              },
              {
                "kind": "Variable",
                "name": "tagCount",
                "variableName": "tagCount"
              },
              (v6/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "ProjectLearningsTabContent"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "ProjectLearningsTabQuery",
    "selections": [
      {
        "alias": "project",
        "args": (v5/*: any*/),
        "concreteType": "Project",
        "kind": "LinkedField",
        "name": "projectByKey",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          (v8/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          {
            "args": (v13/*: any*/),
            "concreteType": "LearningConnection",
            "kind": "LinkedField",
            "name": "learnings",
            "plural": false,
            "selections": [
              (v14/*: any*/),
              {
                "concreteType": "LearningEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "Learning",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "__typename"
                      },
                      (v8/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "type"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v15/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "description"
                          },
                          (v16/*: any*/),
                          {
                            "concreteType": "Project",
                            "kind": "LinkedField",
                            "name": "project",
                            "plural": false,
                            "selections": [
                              (v7/*: any*/),
                              (v17/*: any*/),
                              (v18/*: any*/),
                              (v8/*: any*/),
                              (v16/*: any*/),
                              (v11/*: any*/),
                              (v10/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "Goal",
                            "kind": "LinkedField",
                            "name": "goal",
                            "plural": false,
                            "selections": [
                              (v7/*: any*/),
                              (v17/*: any*/),
                              (v18/*: any*/),
                              (v8/*: any*/),
                              (v16/*: any*/),
                              (v11/*: any*/),
                              {
                                "concreteType": "GoalState",
                                "kind": "LinkedField",
                                "name": "state",
                                "plural": false,
                                "selections": (v9/*: any*/)
                              }
                            ]
                          },
                          {
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "creator",
                            "plural": false,
                            "selections": (v19/*: any*/)
                          },
                          {
                            "kind": "ScalarField",
                            "name": "creationDate"
                          },
                          {
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "lastEditedBy",
                            "plural": false,
                            "selections": (v19/*: any*/)
                          },
                          {
                            "kind": "ScalarField",
                            "name": "lastEditedDate"
                          },
                          {
                            "kind": "ClientExtension",
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "isRecentlyAdded"
                              }
                            ]
                          }
                        ],
                        "type": "Highlight",
                        "abstractKey": "__isHighlight"
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "cursor"
                  }
                ]
              },
              {
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "endCursor"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "hasNextPage"
                  }
                ]
              },
              {
                "kind": "ClientExtension",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__id"
                  }
                ]
              }
            ]
          },
          {
            "args": (v13/*: any*/),
            "filters": [
              "sort",
              "type"
            ],
            "handle": "connection",
            "key": "LearningsList__learnings",
            "kind": "LinkedHandle",
            "name": "learnings"
          },
          {
            "args": [
              {
                "kind": "Variable",
                "name": "first",
                "variableName": "tagCount"
              }
            ],
            "concreteType": "TagConnection",
            "kind": "LinkedField",
            "name": "tags",
            "plural": false,
            "selections": [
              {
                "concreteType": "TagEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "Tag",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      (v20/*: any*/),
                      (v18/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          {
            "concreteType": "UserConnection",
            "kind": "LinkedField",
            "name": "watchers",
            "plural": false,
            "selections": [
              (v14/*: any*/)
            ]
          },
          (v20/*: any*/),
          {
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 6
              },
              (v12/*: any*/),
              (v6/*: any*/)
            ],
            "concreteType": "LearningConnection",
            "kind": "LinkedField",
            "name": "relatedLearnings",
            "plural": false,
            "selections": [
              (v14/*: any*/),
              {
                "concreteType": "LearningEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "Learning",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v15/*: any*/),
                      {
                        "concreteType": "Project",
                        "kind": "LinkedField",
                        "name": "project",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          (v18/*: any*/),
                          (v17/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "0299bcf3269f53f6195e25b5c76ff474",
    "id": null,
    "metadata": {},
    "name": "ProjectLearningsTabQuery",
    "operationKind": "query",
    "text": "query ProjectLearningsTabQuery(\n  $key: String!\n  $trackViewEvent: TrackViewEvent\n  $learningsSort: [LearningSortEnum]\n  $tagCount: Int\n  $type: LearningType\n) {\n  project: projectByKey(key: $key, trackViewEvent: $trackViewEvent) {\n    ...ProjectLearningsTabContent_37pphG\n    id\n  }\n}\n\nfragment LearningModifierSignatures_data on Highlight {\n  __isHighlight: __typename\n  uuid\n  ari\n  project {\n    key\n    ari\n    id\n  }\n  goal {\n    key\n    ari\n    id\n  }\n  creator {\n    pii {\n      name\n    }\n    ...UserAvatar_2aqwkz\n    id\n  }\n  creationDate\n  lastEditedBy {\n    pii {\n      name\n    }\n    ...UserAvatar_2aqwkz\n    id\n  }\n  lastEditedDate\n}\n\nfragment LearningTags_data on TagConnection {\n  edges {\n    node {\n      id\n      name\n      watcherCount\n    }\n  }\n}\n\nfragment Learning_data on Highlight {\n  __isHighlight: __typename\n  __typename\n  id\n  summary\n  description\n  uuid\n  ari\n  project {\n    id\n    key\n    name\n    uuid\n    ari\n    workspace {\n      uuid\n      id\n    }\n    state {\n      label\n    }\n  }\n  goal {\n    id\n    key\n    name\n    uuid\n    ari\n    workspace {\n      uuid\n      id\n    }\n    state {\n      label\n    }\n  }\n  ...LearningModifierSignatures_data\n}\n\nfragment LearningsList_2M1Xv6 on Project {\n  learnings(sort: $learningsSort, first: 200, type: $type) {\n    count\n    edges {\n      node {\n        id\n        uuid\n        type\n        ... on Highlight {\n          __isHighlight: __typename\n          ...Learning_data\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  watcherCount\n  tags(first: $tagCount) {\n    ...LearningTags_data\n  }\n}\n\nfragment NewLearningsPanel_2MWLOs on Project {\n  watcherCount\n  tags(first: $tagCount) {\n    edges {\n      node {\n        watcherCount\n        name\n        id\n      }\n    }\n  }\n}\n\nfragment ProjectLearningsTabContent_37pphG on Project {\n  id\n  uuid\n  state {\n    label\n  }\n  workspace {\n    uuid\n    id\n  }\n  learnings(sort: $learningsSort, first: 200, type: $type) {\n    count\n    edges {\n      node {\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  tags(first: $tagCount) {\n    edges {\n      node {\n        id\n        watcherCount\n      }\n    }\n  }\n  watchers {\n    count\n  }\n  ...LearningsList_2M1Xv6\n  ...RelatedLearnings_s5dLK\n  ...NewLearningsPanel_2MWLOs\n}\n\nfragment RelatedLearning on Learning {\n  uuid\n  summary\n  project {\n    id\n    name\n    key\n  }\n}\n\nfragment RelatedLearnings_s5dLK on Project {\n  relatedLearnings(sort: $learningsSort, first: 6, type: $type) {\n    count\n    edges {\n      node {\n        id\n        ...RelatedLearning\n      }\n    }\n  }\n}\n\nfragment UserAvatar_2aqwkz on User {\n  aaid\n  pii {\n    picture\n    accountId\n  }\n}\n"
  }
};
})();

(node as any).hash = "cb6cf11298c9987cbfe88c48bf5977bc";

export default node;
